import { Button } from '@/components/ui/button';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function FormationCTA() {
  const { t, i18n } = useTranslation('formations');
  const { locale } = useParams<{ locale: string }>();
  const currentLocale = locale || i18n.language || 'fr';
  return (
    <section className="py-24 bg-gradient-to-br from-aspexit-red to-aspexit-red-dark text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl font-heading font-bold mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-xl mb-8 opacity-90">
            {t('cta.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-white text-aspexit-red hover:bg-aspexit-gray-light"
            >
              <a href="https://noteforms.com/forms/inscription-a-une-formation" target="_blank" rel="noopener noreferrer">{t('cta.registerButton')}</a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/10"
            >
              <Link to={`/${currentLocale}/contact`}>{t('cta.quoteButton')}</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
